export default function AboutHero() {
  return (
    <section className="relative w-full min-h-[520px] overflow-hidden flex items-center pt-36 pb-16">
      {/* Background image */}
      <img
        src="/images/about/hero-collage.webp"
        alt="ISMAN Engineering Facility"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-slate-950/80 via-slate-950/55 to-slate-950/30"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-cyan-950/70 via-transparent to-transparent"></div>
      {/* Top accent line */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-cyan-400/70 to-transparent"></div>

      <div className="relative z-10 w-full flex flex-col items-center justify-center text-center px-6">
        <div className="flex items-center gap-3 mb-5">
          <img src="/logo.png" alt="ISMAN Engineering logo" className="w-16 h-16 rounded-xl bg-white p-1.5 shadow-lg" />
          <div className="text-left">
            <p className="text-cyan-400 text-xs font-bold uppercase tracking-widest">ISMAN</p>
            <p className="text-white/80 text-xs uppercase tracking-widest">Engineering Company</p>
          </div>
        </div>
        <h1 className="text-white text-4xl md:text-5xl font-extrabold uppercase tracking-tight leading-tight">
          About <span className="text-cyan-400">Us</span>
        </h1>
        <p className="text-white/60 text-sm mt-3 max-w-xl">
          Engineering Services · Nairobi, Kenya
        </p>
        {/* Breadcrumb */}
        <div className="flex items-center gap-2 mt-5 text-xs text-white/50">
          <a href="/" className="hover:text-cyan-400 transition-colors cursor-pointer">Home</a>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-cyan-400">About Us</span>
        </div>
      </div>
    </section>
  );
}
